import classnames from 'classnames';
import React from 'react';

import { LoadingIcon } from './Icons';

interface AppLoaderProps {
  style?: React.CSSProperties;
  message?: string;
  className?: string;
}

export default function AppLoader({
  style,
  message,
  className,
}: AppLoaderProps) {
  return (
    <div className={classnames('text-center', className)}>
      <LoadingIcon style={{ fontSize: '2em', marginTop: '10%', ...style }} />
      {message && <div>{message}</div>}
    </div>
  );
}
